/** Tło kafelka kategorii na /znaki-drogowe — plik PNG z public/ (nie wzorzec SVG). */
export const TRAFFIC_SIGN_CATEGORY_TILE_BG_PNG =
  '/zebra-logos/pattern-color-with-text-glass.png' as const

/** To samo tło w dark mode (ciemne tło + wzorzec). */
export const TRAFFIC_SIGN_CATEGORY_TILE_BG_PNG_DARK =
  '/zebra-logos/pattern-color-with-text-glass-black.png' as const

/**
 * Wartość pola `image` w danych kategorii — włącza kafelek: PNG jako tło + overlay znaku.
 */
export const TRAFFIC_SIGN_CATEGORY_ARCHIVE_IMAGE_KEY =
  'traffic-sign-category-tile-png-bg' as const

/** Stary klucz z CMS/cache — ten sam układ (PNG pod spodem, znak jako SVG w img). */
const LEGACY_CATEGORY_TILE_IMAGE_KEY = 'zebra-pattern-glass' as const

export const TRAFFIC_SIGN_CATEGORY_TILE_IMAGE_KEYS = [
  TRAFFIC_SIGN_CATEGORY_ARCHIVE_IMAGE_KEY,
  LEGACY_CATEGORY_TILE_IMAGE_KEY,
] as const

export function isTrafficSignCategoryTileImage(image: string | undefined) {
  if (!image) return false
  return (TRAFFIC_SIGN_CATEGORY_TILE_IMAGE_KEYS as readonly string[]).includes(
    image,
  )
}
